import { render, staticRenderFns } from "./AutoFitComp.vue?vue&type=template&id=202f0f1c&scoped=true"
import script from "./AutoFitComp.vue?vue&type=script&lang=js"
export * from "./AutoFitComp.vue?vue&type=script&lang=js"
import style0 from "./AutoFitComp.vue?vue&type=style&index=0&id=202f0f1c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202f0f1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('202f0f1c')) {
      api.createRecord('202f0f1c', component.options)
    } else {
      api.reload('202f0f1c', component.options)
    }
    module.hot.accept("./AutoFitComp.vue?vue&type=template&id=202f0f1c&scoped=true", function () {
      api.rerender('202f0f1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/components/src/componentsUI/AutoFitComp.vue"
export default component.exports